export interface LatLng {
  lat: number;
  lng: number;
}

/**
 * Parses a raw "lat,lng" string (as stored for check-in/check-out
 * locations) into numeric coordinates. Returns null instead of throwing
 * on malformed/missing input so callers can fall back gracefully.
 */
export function parseLatLngString(
  value: string | null | undefined
): LatLng | null {
  if (!value) return null;
  const parts = value.split(",");
  if (parts.length !== 2) return null;
  const lat = Number(parts[0].trim());
  const lng = Number(parts[1].trim());
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  return { lat, lng };
}

/** Builds a Google Maps URL that points at the given coordinates. */
export function buildGoogleMapsUrl(lat: number, lng: number): string {
  return `https://www.google.com/maps?q=${lat},${lng}`;
}
